import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from  '@angular/common/http';
import { AppComponent } from './app.component';
import { AuthComponent } from './components/auth/auth.component';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { NavComponent } from './components/nav/nav.component';
import { WallboardComponent } from './components/wallboard/wallboard.component';
import { WallboardConfigComponent } from './components/wallboard/wallboard-config/wallboard-config.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService } from '../app/services/auth-guard/auth-guard.service';
import { RoleGuardService } from '../app/services/role-guard/role-guard.service';
import { WallboardAddComponent } from './components/wallboard/wallboard-add/wallboard-add.component';
import { environment } from '../environments/environment';
import { TimeInputComponent } from './components/wallboard/time-input/time-input.component';
import { LobLandingComponent } from './components/pages/lob-landing/lob-landing.component';
import { LogoutComponent } from './components/logout/logout.component';
import { MetricsComponent } from './components/wallboard/metrics/metrics.component';
import { WbConfigComponent } from './components/wallboard/wb-config/wb-config.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QueueSelectorComponent } from './components/custom-forms/queue-selector/queue-selector.component';
import { EntQueueSelectorComponent } from './components/custom-forms/ent-queue-selector/ent-queue-selector.component';
import { NotificationComponent } from './components/message/notification/notification.component';
import { InputClearComponent } from './components/custom-forms/input-clear/input-clear.component';
import { TetheredInputComponent } from './components/custom-forms/tethered-input/tethered-input.component';
import { TetheredTimeInputComponent } from './components/custom-forms/tethered-time-input/tethered-time-input.component';
import { TimeDisplayComponent } from './components/custom-forms/time-display/time-display.component';
import { BlacklistComponent } from './components/pages/blacklist/blacklist.component';
import { DataGridComponent } from './components/custom-forms/data-grid/data-grid.component';
import { ResponseTextComponent } from './components/custom-forms/response-text/response-text.component';
import { LOBManagementComponent } from './components/pages/lobmanagement/lobmanagement.component';
import { MessagePageComponent } from './components/pages/message-page/message-page.component';
import { GroupEditorComponent } from './components/custom-forms/group-editor/group-editor.component';
import { AssignMessageComponent } from './components/pages/assign-message/assign-message.component';
import { FooterComponent } from './components/footer/footer.component';
import { HiMarleyManagementComponent } from './components/pages/hiMarley-management/hiMarley-management.component';
import { EmergencyShutdownComponent } from './components/pages/emergency-shutdown/emergency-shutdown.component';
import { QueueMessageComponent } from './components/pages/queue-message/queue-message.component';
import { ClosuresComponent } from './components/pages/closures/closures.component';
import { DispositionComponent } from './components/pages/disposition/disposition.component';
import { ComboBoxComponent } from './components/custom-forms/combo-box/combo-box.component';
import { FormatManagementComponent } from './components/pages/format-management/format-management.component';
import { ConnectUtilComponent } from './components/pages/connect-util/connect-util.component';
import { DispositionGroupManagementComponent } from './components/pages/disposition/tabs/disposition-group-management/disposition-group-management.component';
import { CcpConfigurationComponent } from './components/pages/ccp-configuration/ccp-configuration.component';
import { ToggleSwitchComponent } from './components/custom-forms/toggle-switch/toggle-switch.component';
import { SupervisorOverflowComponent } from './components/pages/supervisor-overflow/supervisor-overflow.component';
import { OverflowUploadComponent } from './components/pages/supervisor-overflow/tabs/overflow-upload/overflow-upload.component';
import { VoicemailExtensionUploadComponent } from './components/pages/voicemail/tabs/voicemail-extension-upload/voicemail-extension-upload.component';
import { ContactUpdateComponent } from './components/pages/contact-update/contact-update.component';
import { HolidayComponent } from './components/pages/message-page/tabs/holiday/holiday.component';
import { CtrOperationsComponent } from './components/pages/ctr-operations/ctr-operations.component';
import { RecordingPlayerComponent } from './components/pages/recording-player/recording-player.component';
import { TestComponent } from './components/pages/test/test.component';
import { MatDataGridComponent } from './components/custom-forms/mat-data-grid/mat-data-grid.component';
import { VoicemailExtensionComponent } from './components/pages/voicemail/tabs/voicemail-extension/voicemail-extension.component';
import { GroupVoicemailComponent } from './components/pages/voicemail/tabs/group-voicemail/group-voicemail.component';
import { AgentVoicemailComponent } from './components/pages/voicemail/tabs/agent-voicemail/agent-voicemail.component';
import { SpecialMessagingComponent, UniqueKeyValidator } from './components/pages/special-messaging/special-messaging.component';
import { DtcCampaignsComponent, UniqueNameValidator } from './components/pages/dtc-campaigns/dtc-campaigns.component';
import { quickConnectReportComponent } from './components/pages/connect-util/quickConnect-report/quickConnect-report.component';
import { InvadersComponent } from './components/misc/invaders/invaders.component';
import { UniqueANIValidator } from './components/pages/ani-config/ani-config.component';
import { AniConfigComponent } from './components/pages/ani-config/ani-config.component';
import { MainstreetBatchUploadComponent } from './components/pages/ani-config/tabs/mainstreet-batch-upload/mainstreet-batch-upload.component';
import { PresetMessagesComponent } from './components/pages/preset-messages/preset-messages.component';
import { MessageModalComponent } from './components/pages/preset-messages/message-modal/message-modal.component';
import { ApplicationDataComponent } from './components/pages/application-data/application-data.component';
import { MatchManagementComponent } from './components/pages/format-management/tabs/match-management/match-management.component';
import { ContactflowreportComponent } from './components/pages/connect-util/contactflowreport/contactflowreport.component';
import { JsonDialogComponent } from './components/custom-forms/json-dialog/json-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SelectAndDisplayComponent } from './components/custom-forms/select-and-display/select-and-display.component';
import { ClaimSearchComponent } from './components/pages/recording-player/search-tabs/claim-search/claim-search.component';
import { PolicySearchComponent } from './components/pages/recording-player/search-tabs/policy-search/policy-search.component';
import { VoicemailComponent } from './components/pages/voicemail/voicemail.component';
import { VMDataGridComponent } from './components/custom-forms/vm-data-grid/vm-data-grid.component';
import { VoicemailManagerComponent } from './components/pages/voicemail-manager/voice-manager/voice-manager.component';
import { AdvancedNotificationComponent } from './components/pages/advanced-notification/advanced-notification.component';
import { ChatTestComponent } from './components/pages/chat-test/chat-test.component';
import { WallboardLifeComponent } from './components/wallboard/wallboard-life/wallboard-life.component';
import { WallboardAddLifeComponent } from './components/wallboard/wallboard-add-life/wallboard-add-life.component';
import { WallboardConfigLifeComponent } from './components/wallboard/wallboard-config-life/wallboard-config-life.component';
import { WbConfigLifeComponent } from './components/wallboard/wb-config-life/wb-config-life.component';

const appRoutes: Routes = [
  // GENERAL ----------------------------------------------------------
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: ['bui']
    }
  },

  // LOBS --------------------------------------------------------------
  {
    path: 'health',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthConfig, environment.authRoles.healthWallboard]
    }
  },
  {
    path: 'fnol',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [ environment.authRoles.fnolConfig, environment.authRoles.fnolWallboard]
    }
  },
  {
    path: 'life',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeConfig, environment.authRoles.lifeWallboard]
    }
  },
  {
    path: 'auto',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.auto.main]
    }
  },
  {
    path: 'claims',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.claims.main]
    }
  },
  {
    path: 'hr',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.hr.main]
    }
  },
  {
    path: 'it',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.it.main]
    }
  },
  {
    path: 'pnc',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.pnc.main]
    }
  },
  {
    path: 'insidesales',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.insidesales.main]
    }
  },
  {
    path: 'aacc',
    component: LobLandingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.roles.aacc.main]
    }
  },
  //HR ---------------------------------------------------------------------
  {
    path: 'hr/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.hrWallboard]
    }
  },
  {
    path: 'hr/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.hrWallboard]
    }
  },
  {
    path: 'hr/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.hrWallboard]
    }
  },
    {
    path: 'hr/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  {
    path: 'hr/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  {
    path: 'hr/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  {
    path: 'hr/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  {
    path: 'hr/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  {
    path: 'hr/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  
  {
    path: 'hr/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.hrConfig]
    }
  },
  //INSIDE SALES -----------------------------------------------------------
  {
    path: 'insidesales/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.insidesalesWallboard]
    }
  },
  {
    path: 'insidesales/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.insidesalesWallboard]
    }
  },
  {
    path: 'insidesales/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.insidesalesWallboard]
    }
  },
  {
    path: 'insidesales/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.insidesales]
    }
  },
  {
    path: 'insidesales/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.insidesalesConfig]
    }
  },
  {
    path: 'insidesales/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.insidesalesConfig]
    }
  },
  {
    path: 'insidesales/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf:[environment.authRoles.insidesalesConfig]
    }
  },
  {
    path: 'insidesales/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.insidesalesConfig]
    }
  },
  {
    path: 'insidesales/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.insidesalesConfig]
    }
  },
  {
    path: 'insidesales/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.insidesalesConfig]
    }
  },
  //PNC -----------------------------------------------------------
  {
    path: 'pnc/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.pncWallboard]
    }
  },
  {
    path: 'pnc/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.pncWallboard]
    }
  },
  {
    path: 'pnc/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.pncWallboard]
    }
  },
  {
    path: 'pnc/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.pnc]
    }
  },
  {
    path: 'pnc/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf:[environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/hiMarley-management',
    component: HiMarleyManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  {
    path: 'pnc/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.pncConfig]
    }
  },
  //CLAIMS -----------------------------------------------------------------
  {
    path: 'claims/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.claimsWallboard]
    }
  },
  {
    path: 'claims/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.claimsWallboard]
    }
  },
  {
    path: 'claims/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.claimsWallboard]
    }
  },
  {
    path: 'claims/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },
  {
    path: 'claims/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.claimsConfig]
    }
  },

  //HEALTH -----------------------------------------------------------------
  {
    path: 'health/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthWallboard]
    }
  },
  {
    path: 'health/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthWallboard]
    }
  },
  {
    path: 'health/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthWallboard]
    }
  },
  {
    path: 'health/wallboard/:site',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthWallboard]
    }
  },
  {
    path: 'health/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
    {
    path: 'health/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
  {
    path: 'health/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
  {
    path: 'health/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
  {
    path: 'health/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
  {
    path: 'health/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },
  {
    path: 'health/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.healthConfig]
    }
  },

  //FNOL ------------------------------------------------------------------
  {
    path: 'fnol/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.fnolWallboard]
    }
  },
  {
    path: 'fnol/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.fnolWallboard]
    }
  },
  {
    path: 'fnol/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.fnolWallboard]
    }
  },
  {
    path: 'fnol/wallboard/:site',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.fnolWallboard]
    }
  },
  {
    path: 'fnol/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  {
    path: 'fnol/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.fnolConfig]
    }
  },
  //LIFE --------------------------------------------------------------------
  // {
  //   path: 'life/wallboard',
  //   component: WallboardComponent,
  //   canActivate: [AuthGuardService, RoleGuardService],
  //   data: {
  //     requiredMemberOf: [environment.authRoles.lifeWallboard]
  //   }
  // },
  {
    path: 'life/wallboard-life',
    component: WallboardLifeComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeWallboard]
    }
  },
  // {
  //   path: 'life/wallboard/config',
  //   component: WallboardConfigComponent,
  //   canActivate: [AuthGuardService, RoleGuardService],
  //   data: {
  //     requiredMemberOf: [environment.authRoles.lifeWallboard]
  //   }
  // },
  {
    path: 'life/wallboard-life/config-life',
    component: WallboardConfigLifeComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeWallboard]
    }
  },
  // {
  //   path: 'life/wallboard/add',
  //   component: WallboardAddComponent,
  //   canActivate: [AuthGuardService, RoleGuardService],
  //   data: {
  //     requiredMemberOf: [environment.authRoles.lifeWallboard]
  //   }
  // },
  {
    path: 'life/wallboard-life/add-life',
    component: WallboardAddLifeComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeWallboard]
    }
  },
  // {
  //   path: 'life/wallboard/:site',
  //   component: WallboardComponent,
  //   canActivate: [AuthGuardService, RoleGuardService],
  //   data: {
  //     requiredMemberOf: [environment.authRoles.lifeWallboard]
  //   }
  // },
  {
    path: 'life/wallboard-life/:site',
    component: WallboardLifeComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeWallboard]
    }
  },
    {
    path: 'life/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },
  {
    path: 'life/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.lifeConfig]
    }
  },

  //IT ---------------------------------------------------------------

  {
    path: 'it/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.itWallboard]
    }
  },
  {
    path: 'it/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.itWallboard]
    }
  },
  {
    path: 'it/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.itWallboard]
    }
  },
  {
    path: 'it/wallboard/:site',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.itWallboard]
    }
  },
    {
    path: 'it/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  {
    path: 'it/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.itConfig]
    }
  },
  //AACC -----------------------------------------------------------
  {
    path: 'aacc/wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.aaccWallboard]
    }
  },
  {
    path: 'aacc/wallboard/config',
    component: WallboardConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.aaccWallboard]
    }
  },
  {
    path: 'aacc/wallboard/add',
    component: WallboardAddComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.aaccWallboard]
    }
  },
  {
    path: 'aacc/disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aacc/dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aacc/group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aacc/queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf:[environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aacc/closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aacc/emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },
  {
    path: 'aaccc/voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.aaccConfig]
    }
  },

  //TELECOM ---------------------------------------------------------------
  {
    path:'ctrProcessing',
    component: ContactUpdateComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path:'applicationData',
    component: ApplicationDataComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'voicemail',
    component: VoicemailComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'blacklist',
    component: BlacklistComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'LOBManagement',
    component: LOBManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService]
     ,data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'message',
    component: MessagePageComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom, environment.authRoles.pnc]
    }
  },
  {
    path: 'group-message',
    component: AssignMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'emergencyShutdown',
    component: EmergencyShutdownComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'closures',
    component: ClosuresComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'queue-message',
    component: QueueMessageComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'disposition',
    component: DispositionComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
       requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'regex',
    component: FormatManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'connectUtil',
    component: ConnectUtilComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'supervisorOverflow',
    component: SupervisorOverflowComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'dispositionGroups',
    component: DispositionGroupManagementComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'ccpConfig',
    component: CcpConfigurationComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    }
  },
  {
    path: 'recordingSearch',
    component: RecordingPlayerComponent,
    canActivate: [AuthGuardService, RoleGuardService], 
    data: {
      requiredMemberOf: [environment.authRoles.policySearch]//Auth roles issue? see nav comment
    }
  },
  {
    path: 'test',
    component: TestComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: []
    }
  },
  {
    path: 'specialMessaging',
    component: SpecialMessagingComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.specialMsg, environment.authRoles.specialMsgSuper]
    }
  },
  {
    path: 'DNISConfig',
    component: DtcCampaignsComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.DNISConfig]
    },
  },
  {
    path: 'ANIConfig',
    component: AniConfigComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.ANIConfig]
    },
  },  
  {
    path: 'presetMessages',
    component: PresetMessagesComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    },
  },
  {
    path: 'voicemailManager',
    component: VoicemailManagerComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom]
    },
  },
  {
    path: 'advancedNotification',
    component: AdvancedNotificationComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.specialMsg, environment.authRoles.specialMsgSuper]
    },
  },
  {
    path: 'chat-test',
    component: ChatTestComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemeberOf: [environment.authRoles.telecom]
    }
  },
  //CTR Operations --------------------------------------------------------
  {
    path: 'ctrOperations',
    component: CtrOperationsComponent,
    canActivate: [AuthGuardService, RoleGuardService],
    data: {
      requiredMemberOf: [environment.authRoles.telecom, environment.authRoles.ctr]
    }
  },
]

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    HomeComponent,
    NavComponent,
    WallboardComponent,
    WallboardConfigComponent,
    LoginComponent,
    WallboardAddComponent,
    TimeInputComponent,
    LobLandingComponent,
    LogoutComponent,
    MetricsComponent,
    WbConfigComponent,
    QueueSelectorComponent,
    EntQueueSelectorComponent,
    NotificationComponent,
    InputClearComponent,
    TetheredInputComponent,
    TetheredTimeInputComponent,
    TimeDisplayComponent,
    VoicemailComponent,
    BlacklistComponent,
    DataGridComponent,
    ResponseTextComponent,
    LOBManagementComponent,
    MessagePageComponent,
    GroupEditorComponent,
    HolidayComponent,
    AssignMessageComponent,
    FooterComponent,
    HiMarleyManagementComponent,
    EmergencyShutdownComponent,
    QueueMessageComponent,
    ClosuresComponent,
    DispositionComponent,
    ComboBoxComponent,
    FormatManagementComponent,
    ConnectUtilComponent,
    DispositionGroupManagementComponent,
    CcpConfigurationComponent,
    ToggleSwitchComponent,
    SupervisorOverflowComponent,
    OverflowUploadComponent,
    VoicemailExtensionUploadComponent,
    ContactUpdateComponent,
    CtrOperationsComponent,
    RecordingPlayerComponent,
    TestComponent,
    MatDataGridComponent,
    VoicemailExtensionComponent,
    GroupVoicemailComponent,
    AgentVoicemailComponent,
    CtrOperationsComponent,
    SpecialMessagingComponent,
    DtcCampaignsComponent,
    quickConnectReportComponent,
    InvadersComponent,
    AniConfigComponent,
    MainstreetBatchUploadComponent,
    PresetMessagesComponent,
    MessageModalComponent,
    MatchManagementComponent,
    MainstreetBatchUploadComponent,
    ApplicationDataComponent,
    ContactflowreportComponent,
    JsonDialogComponent,
    SelectAndDisplayComponent,
    ClaimSearchComponent,
    PolicySearchComponent,
    VoicemailManagerComponent,
    VMDataGridComponent,
    AdvancedNotificationComponent,
    ChatTestComponent,
    WallboardLifeComponent,
    WallboardAddLifeComponent,
    WallboardConfigLifeComponent,
    WbConfigLifeComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatTabsModule,
    MatSliderModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    RouterModule.forRoot(
      appRoutes,
      {
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    relativeLinkResolution: 'legacy'
}
    ),
    BrowserAnimationsModule
  ],
  entryComponents: [MessageModalComponent],
  providers: [AuthGuardService, RoleGuardService, UniqueKeyValidator, UniqueNameValidator, UniqueANIValidator],
  bootstrap: [AppComponent]
})
export class AppModule { }
